let activeMega = null;

function openMega(id) {
  const backdrop = document.getElementById('mega-backdrop');
  if (activeMega === id) { closeMega(); return; }
  closeMega(false);
  activeMega = id;
  document.getElementById('mega-' + id)?.classList.remove('hidden');
  backdrop?.classList.remove('hidden');
  document.querySelectorAll('.nav-btn').forEach(btn => {
    const active = btn.dataset.target === 'mega-' + id;
    btn.setAttribute('aria-expanded', active ? 'true' : 'false');
    btn.querySelector('.nav-chevron').style.transform = active ? 'rotate(180deg)' : '';
    btn.classList.toggle('text-blue-600', active);
    btn.classList.toggle('border-blue-600', active);
  });
}

function closeMega(clearActive = true) {
  const backdrop = document.getElementById('mega-backdrop');
  if (clearActive) activeMega = null;
  document.querySelectorAll('.mega-panel').forEach(p => p.classList.add('hidden'));
  backdrop?.classList.add('hidden');
  document.querySelectorAll('.nav-btn').forEach(btn => {
    btn.setAttribute('aria-expanded', 'false');
    btn.querySelector('.nav-chevron').style.transform = '';
    btn.classList.remove('text-blue-600', 'border-blue-600');
  });
}

function closeMobileMenu() {
  const mobileMenu = document.getElementById('mobile-menu');
  if (!mobileMenu) return;
  mobileMenu.classList.add('hidden');
  document.getElementById('icon-open')?.classList.remove('hidden');
  document.getElementById('icon-close')?.classList.add('hidden');
  document.body.style.overflow = '';
}

function initNav() {
  closeMega();
  closeMobileMenu();

  const mobileBtn  = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileBtn) {
    mobileBtn.onclick = () => {
      const hidden = mobileMenu.classList.toggle('hidden');
      document.getElementById('icon-open').classList.toggle('hidden', !hidden);
      document.getElementById('icon-close').classList.toggle('hidden', hidden);
      document.body.style.overflow = hidden ? '' : 'hidden';
    };
  }

  mobileMenu?.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', closeMobileMenu);
  });

  document.querySelectorAll('.mobile-accordion').forEach(acc => {
    const btn = acc.querySelector('.mobile-accordion-btn');
    if (btn) btn.onclick = () => {
      const section = acc.querySelector('.mobile-section');
      const chevron = acc.querySelector('.mobile-acc-chevron');
      const isOpen  = section.classList.toggle('open');
      chevron.style.transform = isOpen ? 'rotate(180deg)' : '';
    };
  });

  const backdrop = document.getElementById('mega-backdrop');

  document.querySelectorAll('.nav-btn').forEach(btn => {
    btn.onclick = (e) => {
      e.stopPropagation();
      openMega(btn.dataset.target.replace('mega-', ''));
    };
  });

  if (backdrop) backdrop.onclick = () => closeMega();

  document.querySelectorAll('.mega-panel a').forEach(a => {
    a.onclick = () => closeMega();
  });
}

function openDisclosure() {
  document.getElementById('ad-disclosure-modal').classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeDisclosure() {
  document.getElementById('ad-disclosure-modal').classList.add('hidden');
  document.body.style.overflow = '';
}

function initDisclosure() {
  document.querySelectorAll('[data-disclosure]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openDisclosure(); });
  });
  document.getElementById('ad-disclosure-close')?.addEventListener('click', closeDisclosure);
  document.getElementById('ad-disclosure-backdrop')?.addEventListener('click', closeDisclosure);
}

document.addEventListener('turbo:load', initNav);
document.addEventListener('turbo:load', initDisclosure);
document.addEventListener('DOMContentLoaded', initNav);
document.addEventListener('DOMContentLoaded', initDisclosure);
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMega(); closeDisclosure(); } });
